import ChatbotIcon from '#/assets/svgs/ChatbotIcon.svg';
import { ChatMessages, ChatbotHeader, FaqList, LeadForm, MessageInput, useChatbotWidget } from '..';

function ChatbotPreview() {
  const {
    chatbotData,
    messages,
    isSending,
    isFieldSubmit,
    inputField,
    leadFormik,
    isUploadFileLoading,
    reactions,
    renderLeadForm,
    updateMessages,
    handleChange,
    handleEnterKeyPress,
    submitForm,
    handleReaction,
    handleFileChange,
    handleTelInputChange,
    handleLeadFormClose,
    isResponsive,
    contentRef,
    handleSelectChange,
    uploadedFiles,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
    isFetching,
  } = useChatbotWidget();

  const {
    setting: {
      botName = '',
      position = 'right',
      welcomeMessage = '',
      onlineStatus = '',
      color = '',
      textColor = '',
      whatsappAdded = false,
      whatsappNumber = '',
      faqs = [],
      additionalNoteEnabled = false,
      additionalNoteLinkText = '',
      additionalNoteText = '',
      privacyPolicyDocument = {},
      messagePlaceholder = '',
    } = {},
  } = chatbotData?.data || {};

  const chatBotImage = chatbotData?.data?.setting?.chatbotImage?.image || '';

  const closeShowPreview = () => {
    window.parent.postMessage({ action: 'close' }, '*');
  };

  if (isFetching) return null;

  return (
    <div
      className={`preview-content ${isResponsive ? 'responsive-preview-content' : ''}`}
      style={{
        '--chatbot-bg': color,
        '--chatbot-text-color': textColor,
        [position]: '36px',
      }}
    >
      <ChatbotHeader
        botName={botName}
        onlineStatus={onlineStatus}
        color={color}
        textColor={textColor}
        chatBotImage={chatBotImage}
        whatsappAdded={whatsappAdded}
        whatsappNumber={whatsappNumber}
        isResponsive={isResponsive}
        onClose={closeShowPreview}
      />

      <div className="content" ref={contentRef}>
        <div className="welcome-message">
          <div className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</div>
          <p>{welcomeMessage}</p>
        </div>

        <ChatMessages
          messages={messages}
          color={color}
          textColor={textColor}
          chatBotImage={chatBotImage}
          reactions={reactions}
          handleReaction={handleReaction}
          isSending={isSending}
        />

        {renderLeadForm?.lead?.fields?.length > 0 && (
          <LeadForm
            lead={renderLeadForm.lead}
            leadFormik={leadFormik}
            handleFileChange={handleFileChange}
            handleSelectChange={handleSelectChange}
            handleRemoveFile={handleRemoveFile}
            handleTelInputChange={handleTelInputChange}
            handleLeadFormClose={handleLeadFormClose}
            isFieldSubmit={isFieldSubmit}
            isUploadFileLoading={isUploadFileLoading}
            isProcessingFiles={isProcessingFiles}
            uploadedFiles={uploadedFiles}
            fileRef={fileRef}
            color={color}
            textColor={textColor}
            isLeadSubmitLoading={isLeadSubmitLoading}
          />
        )}
      </div>

      <div className="footer">
        <FaqList faqs={faqs} isSending={isSending} updateMessages={updateMessages} />
        <MessageInput
          inputField={inputField}
          isSending={isSending}
          handleChange={handleChange}
          handleEnterKeyPress={handleEnterKeyPress}
          submitForm={submitForm}
          placeholder={messagePlaceholder}
        />
        {additionalNoteEnabled && (
          <div className="additional-note-wrapper">
            <span>
              {additionalNoteText}
              <a href={privacyPolicyDocument?.file} target="_blank" download>
                {additionalNoteLinkText}
              </a>
            </span>
          </div>
        )}
        <p className="powered-by">
          Powered by{' '}
          <a href="https://booosted.fi" target="_blank">
            Booosted.fi
          </a>
        </p>
      </div>
    </div>
  );
}

export default ChatbotPreview;
